module.exports = __webpack_public_path__ + "img/block_02_img.b55f7c26.png";